import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

type TrainerTokenValue = { token: string; setToken: (value: string) => void }

const TrainerTokenContext = createContext<TrainerTokenValue | null>(null)

/** One token for the training chat and the call-flow page. Kept in memory only. */
export function TrainerTokenProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState('')
  const value = useMemo(() => ({ token, setToken }), [token])
  return <TrainerTokenContext.Provider value={value}>{children}</TrainerTokenContext.Provider>
}

export function useTrainerToken(): TrainerTokenValue {
  const value = useContext(TrainerTokenContext)
  if (!value) throw new Error('useTrainerToken must be used inside TrainerTokenProvider')
  return value
}
